<template>
  <div
    :class="['comment-form', { 'comment-form--expand': isFormVisible }]"
    @click="openForm"
    @keydown="keyPressed"
  >
    <!-- TODO fix click outside  -->
    <el-avatar class="comment-form__avatar" :size="36">
      <user-avatar :userId="currentUser.userId" :alt="currentUser.firstName + ' ' + currentUser.lastName" />
    </el-avatar>

    <div class="comment-form__label">
      Add a comment
    </div>

    <el-input
      v-model="text"
      class="comment-form__input"
      ref="input"
      :rows="2"
      name="comment-form-text"
      @input="autoSizeTextarea"
      maxlength="2000"
      style="width: 240px"
      :autosize="{ minRows: 1, maxRows: 4 }"
      type="textarea"
      placeholder="Write comment"/>

    <div class="comment-form__bottom">
      <!--div class="comment-form__extra">
        <el-button icon="el-icon-camera" type="primary" />
        <el-button icon="el-icon-video-camera" type="primary" />
        <el-button icon="el-icon-location-outline" type="primary" />
      </div-->

      <div class="comment-form__buttons">
        <el-button type="primary" @click.stop="onCancel">
          Cancel
        </el-button>
        <el-button
          type="primary"
          @click="validate"
          :disabled="isButtonDisabled('save-comment')"
        >
          {{ isNew ? 'Add comment' : 'Save' }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { updateEventEntry, addEventPostComment } from '@/api/events.js';
import { addComment, updateComment } from '@/api/blog.js';
import { showMessage } from '@/utils/messages.js';
import { disableButton } from '@/mixins/disableButton.js';
import UserAvatar from '@/components/profile/UserAvatar.vue';

export default {
  name: 'CommentForm',
  props: {
    postId: {
      type: Number,
      required: true,
    },
    id: {
      type: Number,
      required: false
    },
    oldContent: {
      type: String,
      required: false,
    },
    isNew: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    UserAvatar,
  },
  computed: {
    currentUser() {
      return this.$store.state.user;
    },
  },
  mixins: [disableButton],
  data() {
    return {
      isFormVisible: false,
      text: null,
      inputHeight: null,
      lastTarget: null,
    };
  },
  methods: {
    showMessage,
    async requestAddEventPostComment() {
      this.disableButton('save-comment');

      const { eventPostId, text } = this;
      const { success } = await addEventPostComment({
        eventPostId,
        text: text.trim(),
      });
      this.enableButton('save-comment');

      if (success) {
        this.$emit('update-data');
        this.clearInput();
      }
    },
    async requestAddComment() {
      this.disableButton('save-comment');

      const { postId, text } = this;
      const { success } = await addComment(
        postId,
        text.trim(),
      );
      this.enableButton('save-comment');

      if (success) {
        this.$emit('update-data');
        this.clearInput();
      }
    },
    async requestUpdateEventEntry() {
      this.disableButton('save-comment');

      const { eventLogEntryId } = this;
      const { text } = this;

      const { success } = await updateEventEntry({
        eventLogEntryId,
        text: text.trim(),
      });
      this.enableButton('save-comment');

      if (success) {
        this.$emit('update-data');
        this.$emit('close-form');
        this.clearInput();
      }
    },

    async requestUpdateComment() {
      this.disableButton('save-comment');

      const { id } = this;
      const { text } = this;

      const { success } = await updateComment(
        id,
        text.trim());
      this.enableButton('save-comment');

      if (success) {
        this.$emit('update-data');
        this.$emit('close-form');
        this.clearInput();
      }
    },

    toggleForm() {
      this.isFormVisible = !this.isFormVisible;
    },
    openForm() {
      if (!this.isFormVisible) {
        this.isFormVisible = true;

        const input = this.$refs.input;
        if (input) {
          this.$nextTick(() => input.focus());
        }
      }
    },
    validate() {
      const { text, isNew, postId } = this;

      if (text && text.trim()) {
        if (isNew) {
          if (postId) {
            this.requestAddComment();
          } 
        } else {
          this.requestUpdateComment();
        }
      } else {
        this.showMessage({
          type: 'error',
          message: 'Please enter comment text',
        });
      }
    },
    autoSizeTextarea() {
      const { text } = this;
      const input = this.$refs.input;

      // TODO check if lesser lines
      if (input) {
        this.$nextTick(() => {
          if (text && text.trim()) {
            const { inputHeight } = this;
            const newInputHeight = input.scrollHeight;
            const newInputHeightWithOffset = newInputHeight + 30;

            if (inputHeight && inputHeight < newInputHeight) {
              //input.style.cssText = 'height:' + newInputHeightWithOffset + 'px';
            }

            this.inputHeight =
              inputHeight && inputHeight < newInputHeight
                ? newInputHeightWithOffset
                : newInputHeight;
          } else {
            //input.style.cssText = 'height: 36px';
          }
        });
      }
    },
    clearInput() {
      this.text = null;

      const input = this.$refs.input ? this.$refs.input : null;
      if (input) {
        //input.style.cssText = 'height: 36px';
      }
    },
    keyPressed({ key, shiftKey }) {
      if (key === 'Escape') {
        this.onCancel();
      }
    },
    onCancel() {
      this.$emit('close-form');
      this.isFormVisible = false;
    },
  },
  created() {
    this.autoSizeTextarea();

    const { oldContent } = this;
    if (oldContent) {
      this.text = oldContent;
      this.isFormVisible = true;
    }

    window.addEventListener('mousedown', this.onOverlayMouseDown);
    window.addEventListener('mouseup', this.onOverlayMouseUp);
  },
  beforeDestroy() {
    window.removeEventListener('mousedown', this.onOverlayMouseDown);
    window.removeEventListener('mouseup', this.onOverlayMouseUp);
  },
  watch: {
    oldContent(newVal) {
      this.text = newVal;
      if (newVal) {
        this.isFormVisible = true;
      }
    },
  },
};
</script>

<style lang="scss">
.comment-form {
  $this: &;

  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  overflow: hidden;
  cursor: text;

  // padding: var(--global-dimension-size-200) var(--global-dimension-size-300);

  font-size: var(--font-size-200);

  &--expand {
    cursor: unset;
    flex-wrap: wrap;
    align-items: flex-start;

    #{$this}__label {
      display: none;
    }
    #{$this}__input {
      display: block;
    }
    #{$this}__bottom {
      display: flex;
    }
  }

  &__avatar {
    margin-right: var(--global-dimension-size-125);
  }

  &__label {
  }

  &__input {
    display: none;
    flex-grow: 1;
    max-width: calc(100% - 46px);
    min-height: 36px;
    height: auto;
    padding: 0;

    resize: none;
    border: none;
    box-shadow: none;
    border-radius: unset;
    box-sizing: content-box;
    overflow: hidden;

    line-height: 1.6;

    &:focus {
      border: none;
      outline: none;
    }
  }

  &__bottom {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    display: none;
    margin-top: var(--global-dimension-size-125);
  }

  &__extra {
  }
}
</style>
